import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";

import { registerNavSection } from "./shell/navigation";

registerNavSection({ key: "maintenance", spoke: "maintenance", title: "Maintenance", icon: BuildOutlinedIcon, order: 50, entries: [
  { label: "Dispatch", to: "/app/maintenance", permission: "maintenance.work.view" },
  { label: "Assets", to: "/app/maintenance/assets", permission: "maintenance.asset.view" },
  { label: "Report a problem", to: "/app/maintenance/requests", permission: "maintenance.work.request" },
  { label: "Preventive plans", to: "/app/masterdata/preventive-plans", permission: "maintenance.asset.view" },
  { label: "Downtime log", to: "/app/masterdata/downtime", permission: "maintenance.work.view" },
] });
